export default (date?: Date) => {
  const minDate = date || new Date();

  const year = minDate.getFullYear();
  const month = String(minDate.getMonth() + 1).padStart(2, '0');
  const day = String(minDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
